import { TourIdentifier } from "@tsTypes/__generated__/enums/tour_identifier";

// Note: Make sure to add new flags to `app/services/flipper_gates.rb` too!
const FEATURE_FLAGS = [
  "UNCLAIMED_COMPANY_PAGE",
  "SESSION_TIMEOUT",
  "COMPANY_MARKETPLACE_FILTER",
  "NEW_PROPOSAL_FORM_UI_WITH_REQUIREMENTS",
  "PEPSICO_REVIEWER_DASHBOARD_SORTING",
  "MARKETPLACE_PARTNER_TYPE_FILTER",
  "RFP_FORM_V2_AUDIENCE",
  "KEYWORD_AI_AUTO_POPULATION",
  "REVIEW_COMMENT_AI_SUMMARIES",
  "RELEVANT_NOT_RELEVANT_BUTTONS",
  "NON_ACADEMIC_PROPOSAL_FORM_CHANGES",
  "EMERGE_INSTITUTIONS_PAGES",
  "NEW_PROPOSAL_PAGE",
  "ARCHIVE_REQUESTS",
  "DISCOVER_FEED",
  "RFP_PROGRESSIVE_CONTENT",
  "REPLACE_STARTUP_WITH_COMPANY",
  "INNOVATOR_PROFILE_PAGE",
  "PULSE_CHECKS",
  "INNOVATOR_SOLUTION_LISTINGS",
  "PYLON_CHAT",
] as const;

// Export object of { [name as symbol]: boolean }
export default FEATURE_FLAGS.reduce(
  (obj, flag) => ({
    ...obj,
    [flag]: (typeof gon !== "undefined" && gon.feature_flags?.includes(flag)) || false,
  }),
  {}
) as { [F in (typeof FEATURE_FLAGS)[number]]: boolean };

// Add fully-enabled tours here BEFORE removing the Flipper gate
const DEFAULT_ENABLED_TOURS = [
  TourIdentifier.PROPOSAL_REVIEW_SYSTEM_2024_01_22,
  TourIdentifier.PROPOSAL_REVIEW_SYSTEM_FEEDBACK_DEADLINE_V2_2024_10_31,
  TourIdentifier.ORGANIZATIONS_TAB_2025_08_05,
];

export const isTourEnabled = (tour: TourIdentifier): boolean =>
  DEFAULT_ENABLED_TOURS.includes(tour) ||
  (typeof gon !== "undefined" && gon.feature_flags?.includes(`TOUR_${tour}`)) ||
  false;
